module.exports = __webpack_public_path__ + "img/faq.16a4d9c5.svg";